import { Box, Card, CardContent, Stack, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material";
import CustomBarChart from "../../components/barChart";
import CustomRadarChart from "../../components/radarChart";
import { Info } from "@mui/icons-material";

function MissionCreatedBarchart({createdBarData, avgCreated, avgPercentages}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    return ( 
        <Stack direction={isMobile ? "column" : "row"} spacing={2} sx={{ mt: 4, marginRight: 2 }}>
            <Card sx={{ flex: isMobile ? 1 : 2, borderRadius: 3, boxShadow: 2, backgroundColor: "background.main" }}>
                <CardContent>
                {/* <Typography variant="h9" color="grey" gutterBottom marginRight={2}>
                    Statistics
                </Typography> */}
                <Typography variant="subtitle" fontWeight="bold">
                    Mission Created by Value Tags
                </Typography>
                <CustomBarChart
                    layout="horizontal"
                    data={createdBarData}
                    filledLabel="Created Mission"
                    highestLabel="Highest Created Mission"
                    mode="stacked"
                />
                </CardContent>
            </Card>
            <Card sx={{ flex: isMobile ? 1 : 1.5, borderRadius: 3, boxShadow: 2, backgroundColor: "background.main" }}>
                <CardContent>
                {/* <Typography variant="h9" color="grey" gutterBottom marginRight={2}>
                    Statistics
                </Typography> */}
                <Box display="flex" alignItems="center">
                    <Typography variant="subtitle" fontWeight="bold">
                        Mission Points Created by Value Tags
                    </Typography>
                    <Tooltip
                        title="Represents the total mission points linked to each value tag, shown as a percentage relative to the highest value tag (set at 100%)."
                        arrow
                    >
                        <Info sx={{ ml: 1 }} />
                    </Tooltip>
                </Box>
                <CustomRadarChart
                    metricsWithName={avgCreated.metricsWithName}
                    metrics={avgCreated.metrics}
                    values={avgCreated.values}
                    percentages={avgPercentages.values}
                    valueFormatter={(v) => `${v}%`}
                />
                </CardContent>
            </Card>
            </Stack>
     );
}

export default MissionCreatedBarchart;